module.exports = __webpack_public_path__ + "media/images/emblems/Brienzwiler-coat_of_arms-7adf8b5fac50d08a4cbfc9a88e48a199.svg";